import axios from "axios";
import { response } from "../../lib/utils";
import { showDetailUrl } from "./namespace";


// this api is for showing the more details and normal text using api
export async function showDetails(prompt: string,intent:string, memory: string) {
    try {
        const resp = await axios.post(showDetailUrl, {
            prompt,
            memory,
            intent
        })
        if (resp.status !== 200) {
            return response(false, resp.data.message, resp.data || "Error fetching details");
        }
        return response(true, "Details fetched successfully", resp.data[0].output);
    } catch (error: any) {
        return response(false, error.message, error);
    }
}